module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dialogues"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "seatcheck"
    }
  }, [_c('h2', [_vm._v("Seatcheck")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "83%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v("M=man W=woman")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("Did you do the laundry, dear?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("Yes, I did my love.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("Did you mix the colors, sweetums?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("No, I didn’t my secret sweet.")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("W:")]), _vm._v(" "), _c('td', [_vm._v("Where are the car keys, my bear? Did you check the seat before we left?")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("M:")]), _vm._v(" "), _c('td', [_vm._v("We would not be in this predicament if we were not talking about interracial laundry!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd192846","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0008.vue
// module id = 93
// module chunks = 0